import React, { Component } from 'react'
import { GET_IDEA_URL, APPROVED, PENDING, SENT_BACK, REJECTED, REVIEW_IDEA_URL, DATA_BRIDGE_CAMPAIGN, X_POLLINATION_CAMPAIGN, ACCESS_TOKEN, COMPLETE_STATUS, AWAITING_MASTER_BLACKBELT_APPROVAL, USER_DATA, SIGNOFF_CONTENT, PPT_CONTENT, AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION, BI_FORM_DATE, AWAITING_QAULITY_CHECK_REVIEW, YESORNO, SOLUTIONCOMPLEXITY, REPLICABILITYOPTIONS, AI_DOC_LINK, AIFIRST,AWAITING_PROJECT_APPROVAL, CANCEL } from '../assets/constants/constants';
import Select from 'react-select';
import Toast from 'light-toast';
import { selectValidation as selectStyle, textBoxValidation } from "../utils/FieldValidation";

import UpdatedSpeech from './UpdatedSpeech';
import ValueDelivery from '../utils/ValueDelivery';


export class MbbMonetizationApproval extends Component {
    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN);
    constructor(props) {
        super(props)

        const isApprovalPage = `${this.props.location.approval}`;
        let propsData = this.props.location;
        this.state = {
            ideaItem: {},
            WorkflowStatus: "",
            Comment: "",
            accountName: "",
            campaignName: "",
            serviceLineName: "",
            
            approvalPage: isApprovalPage,
            businessImpactMasterList: [],
            businessImpactValueArray: [],
            summaryArray: [],
            fteTotal: 0,
            dollarTotal: 0.0,
            selectStyle: {},
            mbbComment: "",
            finalApproveOptionsValue: [{
                WorkflowStatusId: 1,
                WorkflowStatusName: "Approved"
            },
            {
                WorkflowStatusId: 3,
                WorkflowStatusName: "Send Back"
            },
            ],
        
            approvalSelectedOption: null,
            propsData: propsData,
            Role: "",
            speechModal: false,
            previousTextForSpeech: "",
            showHistoricalBI: false,
            ideaCreatedDate: "",
            showClientFields: false,
            showGOLFields: false,

            golFilename: "",
            golContent: "",
            golFileType: "",
            golOhr: "",
            golEmail: "",
            golFullname: "",

            fpnaFilename: "",
            fpnaContent: "",
            fpnaFileType: "",
            fpnaName: "",
            fpnaEmail: "",
            fpnaOhr: "",
            fpnaApprovalAttachedSelectedOption: null,

            clientName: "",
            clientRole: "",
            clientSignOffDate: "",
            clientApprovalEmailSelectedOption: null,
            signOffFilename: "",


            vrconditiontype: "",
            vrMapping: "",
            vrRegionMapping: "",
            vrVerticalSplit: "",
            vrResult: "",

            
            approvalStatusState: "",
            awaitingQC: false,
            monetizableProjectSelectedOption: null,
            mbbMonetizableOptions: [
                { value: '0', label: 'Yes' },
                { value: '1', label: 'No' },
            ],
            monetizableStatusOptions: "Approved by Clients",
            finalCommentLog: false,
            commentLog: false,
            qcCommentLog: false,
            qcComments: [],
            qcCommentsWithVD: [],
            monetizationFileContent: null,
            IsSampleCheck: false,
            FinalImpactDollar: "",
            FinalImpactFTE: "",
            lastFinalComment: "",
            totalMonetizedDollar: 0,
            totalMonetizedFTE: 0,
            qcLastComment: "",
            golFpnaFileDetails: [],
            isFpnaRequired: false,
            
            clusterData: [],
            isClusterSaveDisabled: true,
            displayParentAlpha: '',
            projectTypeSelectedOption: null,
            projectIDSelectedOption: null,
            ideasDB: [],
          
            replicabilityIndex: [],
            showHrefModal: false,
           
            campaignList: [],
            campaignInsight: "",

            //AI
            ideasAI: [],
            isIdeaReplicable: "",

            // productivity
            methodologies: "",
            contractedUploadedOHRCount: 0,
            nonContractedUploadedOHRCount: 0,
            totalOHRUploaded: 0,

            CodersTable: []
        }
        this.isExceedlimit = false;
    }

    async componentDidMount() {
        await this.fetchIdea();
    }

    formatDateString(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    fetchIdea = async () => {
        try {
            Toast.loading("Fetching Idea & Metadata...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };

            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    console.log('idea fetch data =>', data)
                    Toast.hide()
                    this.setState({
                        ideaItem: data.ResultSets.Table1[0],
                        reviewComments: data.ReviewComments ? data.ReviewComments : [],
                        finalReviewComments: data.FinalReviewComments ? data.FinalReviewComments : [],
                        WorkflowStatus: data.ResultSets.Table1[0].WorkflowStatus,
                        Comment: data.ResultSets.Table1[0].Comment,
                        qcComments: data.QcComments ? data.QcComments : [],
                        qcCommentsWithVD: data.qcCommentsWithVD ? data.qcCommentsWithVD : [],
                        clusterData: data.ClusterData ? data.ClusterData : [],
                        ideasDB: data.IdeasDB ? data.IdeasDB ? data.IdeasDB[0] : [] : [],
                        ideasAI: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0] : [] : [],
                        CodersTable: data.CodersTable ? data.CodersTable : [],

                        campaignUnionQuery: data.CampaignDetails.ResultSets.Table1,
                        vdForComponent: data.BIData ? data.BIData : [],


                    }, () => {

                        if (this.state.campaignUnionQuery) {
                            let filteredUnionQuery = this.state.campaignUnionQuery.filter((item) => {
                                return item.CampaignID === this.state.ideaItem.CampaignID
                            })
                            if (filteredUnionQuery) {
                                if (filteredUnionQuery[0]) {
                                    this.setState({
                                        campaignInsight: filteredUnionQuery[0].CampaignDescr,
                                    }, () => { }
                                    );
                                }
                            }
                        }
                        if (this.state.ideaItem.MethodologyName) {
                            let localMethodologies = this.state.ideaItem.MethodologyName.replace(/[|,]/g, ", ")
                            localMethodologies = localMethodologies.split(",").join(", ");
                            this.setState({ methodologies: localMethodologies }, () => { })
                        }

                        

                        if (this.state.ideaItem.ReplicabilityIndex) {
                            REPLICABILITYOPTIONS.map((item) => {
                                if (item.value === this.state.ideaItem.ReplicabilityIndex) {
                                    this.setState({ replicabilityIndex: item }, () => { })
                                }
                            })
                        }

                        if (this.state.clusterData && this.state.clusterData.length > 0) {
                            const targetRecID = this.state.ideaItem.LeanID;
                            const filteredData = this.state.clusterData.filter(item => item.RecAlpha === targetRecID);
                            console.log(filteredData)
                            if (filteredData && filteredData.length > 0 && filteredData !== undefined && filteredData !== null) {
                                this.setState({ displayParentAlpha: filteredData[0].ParentAlpha }, () => { })
                                let options = [];
                                options.push({ value: 0, label: filteredData[0].ParentAlpha })
                                this.setState({ projectIDSelectedOption: options }, () => { })

                                let options1 = [];
                                options1.push({ value: 0, label: "GB" })
                                this.setState({ projectTypeSelectedOption: options1 }, () => { })
                            } else {
                                this.setState({ displayParentAlpha: "" }, () => { })
                            }
                        } else {
                            this.setState({ displayParentAlpha: "" }, () => { })
                        }

                        if (this.state.finalReviewComments.length > 0) {
                            var keys = Object.keys(this.state.finalReviewComments);
                            var last = keys[keys.length - 1];
                            let varFinalLastComment = this.state.finalReviewComments[last].Comment
                            this.setState({ lastFinalComment: varFinalLastComment }, () => {
                                console.log("last key =>", this.state.lastFinalComment);
                            })
                        }

                        if (this.state.qcComments.length > 0) {
                            var keys = Object.keys(this.state.qcComments);
                            var last = keys[keys.length - 1];
                            let varQCComment = this.state.qcComments[last].Comment;
                            this.setState({ qcLastComment: varQCComment }, () => {

                            })
                        }
                        if (this.state.ideasAI.length > 0) {
                            if (this.state.ideasAI.IsIdeaReplicable) {
                                this.setState({ isIdeaReplicable: "Yes" }, () => { })
                            } else {
                                this.setState({ isIdeaReplicable: "No" }, () => { })
                            }
                        }
                    });
                }
            }

        } catch (error) {
            console.log("idea failed", JSON.stringify(error))
            Toast.hide()
            Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });
        };
    }

    saveEvent = () => {
        let redirectURL = "/review-page";
        if (this.state.approvalPage) {
            redirectURL = redirectURL + "?page=" + this.state.approvalPage;
            this.props.history.push(redirectURL);
        }
        else {
            this.props.history.push(redirectURL);
        }
    }

    renderStatusOptions = () => {
        let options = [];
        this.state.finalApproveOptionsValue.map((item) => {
            options.push({
                value: item.WorkflowStatusId,
                label: item.WorkflowStatusName
            })
            return options;
        });
        return options;
    }

    handleApprovalStatus = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.approvalSelectedOption = selectStyle(true);
        this.setState({
            approvalSelectedOption: {
                value: e.value,
                label: e.label
            },
            selectStyle: styleStateObj,
            finalComment: "",

        }, () => {
            if (this.state.approvalSelectedOption.label === "Approved") {
                this.setState({ MonetizationState: COMPLETE_STATUS })
            }
            if (this.state.approvalSelectedOption.label === "Send Back") {
                this.setState({ MonetizationState: "Active" })
            }
        });
    }

    submitIdea = () => {
        if (this.validate()) {
            if (window.confirm("Are you sure you want to submit the lean project?")) {
                Toast.loading("lean project updating...", () => { });
                console.log(this.state.approvalSelectedOption.label)
                let param = {};
                if (this.state.approvalSelectedOption.label === "Approved") {
                    param = {
                        ApprovalStatus: this.finalApprovalState(),
                        FinalComments: this.state.finalComment,
                        IsMBBApproval: "MBB",
                        UpdaterOHR: this.sessionData.profile.oHRId,
                        UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                        UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
                        comment: this.state.finalComment,
                        Role: "MBB",
                        CompletedDate: new Date().toLocaleString(),
                        FpnaApprovalAttachedSelectedOption: this.state.ideaItem.IsFPnAApprovalAttached,
                        // IsMbbMonetizable: this.state.monetizableProjectSelectedOption ? "Yes" : "No",
                        case: "new",
                        casetype: "MBBMonetization",
                        MonetizationState: this.finalMonetizationState(),
                        updaterAction: this.state.approvalSelectedOption ? this.state.approvalSelectedOption.label === COMPLETE_STATUS ? "Approved" : this.state.approvalSelectedOption.label : "",


                        IdeaId: this.state.ideaItem.IdeaId,
                        LeanID: this.state.ideaItem.LeanID ? this.state.ideaItem.LeanID : "",
                        IdeaIDAlpha: this.state.ideaItem.IdeaIDAlpha,
                        IdeaName: this.state.ideaItem.IdeaName,

                        OwnerEmail: this.state.ideaItem.CreatorEmail ? this.state.ideaItem.CreatorEmail : this.state.ideaItem.OwnerEmail,
                        OwnerName: this.state.ideaItem.OwnerName,
                        OwnerOHR: this.state.ideaItem.OwnerOHR,

                        BlackBeltUserId: this.state.ideaItem.BlackBeltUserId,
                        BlackBeltUserName: this.state.ideaItem.BlackBeltUserName,
                        MBBOHR: this.state.ideaItem.MBBOHR,
                        MBBName: this.state.ideaItem.MBBName,

                        Account: this.state.ideaItem.AccountManual,
                        Region: this.state.ideaItem.RegionManual,
                        Vertical: this.state.ideaItem.VerticalManual,

                        CertificationLevelName: this.state.ideaItem.CertificationLevelName,
                        TransformationLeverName: this.state.ideaItem.TransformationLeverName,
                        ServiceLineName: this.state.ideaItem.ServiceLineName,
                    }
                }
                else {
                    param = {
                        IdeaId: this.props.location.state,
                        ApprovalStatus: "Active",
                        FinalComments: this.state.finalComment,
                        IsMBBApproval: "MBB",
                        UpdaterOHR: this.sessionData.profile.oHRId,
                        UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                        UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
                        comment: this.state.finalComment,
                        Role: "MBB",
                        FpnaApprovalAttachedSelectedOption: this.state.ideaItem.IsFPnAApprovalAttached,
                        // IsMbbMonetizable: this.state.monetizableProjectSelectedOption ? "Yes" : "No",
                        case: "new",
                        casetype: "MBBMonetization",
                        MonetizationState: "Send Back",
                        updaterAction: this.state.approvalSelectedOption ? this.state.approvalSelectedOption.label === COMPLETE_STATUS ? "Approved" : this.state.approvalSelectedOption.label : "",


                        IdeaId: this.state.ideaItem.IdeaId,
                        LeanID: this.state.ideaItem.LeanID ? this.state.ideaItem.LeanID : "",
                        IdeaIDAlpha: this.state.ideaItem.IdeaIDAlpha,
                        IdeaName: this.state.ideaItem.IdeaName,

                        OwnerEmail: this.state.ideaItem.CreatorEmail ? this.state.ideaItem.CreatorEmail : this.state.ideaItem.OwnerEmail,
                        OwnerName: this.state.ideaItem.OwnerName,
                        OwnerOHR: this.state.ideaItem.OwnerOHR,

                        BlackBeltUserId: this.state.ideaItem.BlackBeltUserId,
                        BlackBeltUserName: this.state.ideaItem.BlackBeltUserName,
                        MBBOHR: this.state.ideaItem.MBBOHR,
                        MBBName: this.state.ideaItem.MBBName,

                        Account: this.state.ideaItem.AccountManual,
                        Region: this.state.ideaItem.RegionManual,
                        Vertical: this.state.ideaItem.VerticalManual,

                        CertificationLevelName: this.state.ideaItem.CertificationLevelName,
                        TransformationLeverName: this.state.ideaItem.TransformationLeverName,
                        ServiceLineName: this.state.ideaItem.ServiceLineName,


                    }
                }
                console.log(param)
                
                const requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    },
                    body: JSON.stringify(param)
                };
                fetch(`${REVIEW_IDEA_URL}`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        Toast.hide();
                        if (data.Message = "Monetization approved MBB succesfully") {
                            Toast.success('Updated successfully.', 3000, () => {
                                window.location = "/review-page?page=leanapproval";
                            });
                        }
                        else{
                            Toast.fail('Failed to update. Please try again...', 3000, () => {
                                window.location = "/review-page?page=leanapproval";
                            });
                        }

                    });
            }
        } else {
            if (!this.isExceedlimit) {
                Toast.fail('Required fields are missing or have invalid values. Please correct and try again.', 3000, () => { });
            }
        }
        return false;
    }
    finalMonetizationState() {
        let localMonetizationState = AWAITING_QAULITY_CHECK_REVIEW;
        if (this.state.ideaItem.QCOHR) {
            localMonetizationState = AWAITING_PROJECT_APPROVAL;
        }
        if (this.state.approvalSelectedOption) {
            if (this.state.approvalSelectedOption.label === 'Send Back') {
                localMonetizationState = "Active"
            }
        }
        return localMonetizationState;
    }

    finalApprovalState=()=>{
        let localApprovalStatus = AWAITING_QAULITY_CHECK_REVIEW;
        if (this.state.ideaItem.QCOHR) {
            localApprovalStatus = AWAITING_PROJECT_APPROVAL;
        }
        return localApprovalStatus;
    }

    validate = () => {
      
        let isValid = true;
        this.isExceedlimit = false;
        let styleStateObj = this.state.selectStyle;

        if (this.state.approvalSelectedOption === null) {
            isValid = false;
            styleStateObj.approvalSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.approvalSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (!this.state.finalComment || this.state.finalComment === "") {
            isValid = false;
            styleStateObj.comment = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            if (this.state.finalComment.length > 500) {
                Toast.fail("Comment cannot be more than 500 characters, please change and resubmit.", 3000);
                isValid = false;
                this.isExceedlimit = true;
                styleStateObj.comment = textBoxValidation(false);
                this.setState({
                    selectStyle: styleStateObj
                })
            }
            else {
                styleStateObj.comment = { ...textBoxValidation(true), border: "1px solid lightgrey" };
                this.setState({
                    selectStyle: styleStateObj
                })
            }
        }

        // if(this.state.monetizableProjectSelectedOption === null){
        //     isValid = false;
        //     styleStateObj.monetizableProjectSelectedOption = selectStyle(false);
        //     this.setState({selectStyle: styleStateObj})
        // }else{
        //     styleStateObj.monetizableProjectSelectedOption = selectStyle(true);
        //     this.setState({selectStyle: styleStateObj})
        // }




        return isValid;
    }

    cancelEvent = () => {
        // this.props.history.push("/review-page?page=approval");
        let redirectURL = "/review-page";
        if (this.state.approvalPage) {
            // redirectURL = redirectURL + "?page=" + this.state.approvalPage;
            // this.props.history.push(redirectURL);
            this.props.history.push({
                pathname: redirectURL,
                search: '?page=' + this.state.approvalPage,
                propsList: this.state.propsData
            })
        }
        else {
            // this.props.history.push(redirectURL);
            this.props.history.push({
                pathname: redirectURL,
                propsList: this.state.propsData
            })
        }
    }

    handleFinalCommentChange = (event) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.comment = textBoxValidation(true);
        this.setState({
            finalComment: event.target.value,
            selectStyle: styleStateObj
        });





    }
    handleTranscriptMBBComment = (e) => {
        this.setState({
            finalComment: e
        });
    }


    formatDateStringWithTime(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }

    toggleTranscriptFunction = (id) => {
        this.setState({ speechModal: !this.state.speechModal, modalIndex: id })
        if (id === 8) {
            if (this.state.finalComment) {
                this.setState({ previousTextForSpeech: this.state.finalComment }, () => console.log(this.state.previousTextForSpeech))
            } else {
                this.setState({ previousTextForSpeech: "" }, () => console.log(this.state.previousTextForSpeech))
            }
        }
    }

    closeModalFunction = () => {
        this.setState({ speechModal: false })
    }
    renderMonetizableOptions = () => {
        let options = [];
        this.state.mbbMonetizableOptions.map((item) => {
            options.push({
                value: item.value,
                label: item.label
            })
            return options;
        });
        return options;
    }
    handleMonetizableMBBApproval = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.monetizableProjectSelectedOption = selectStyle(true);
        this.setState({ monetizableProjectSelectedOption: e, selectStyle: styleStateObj })
    }

    newBusinessImpactSummary() {
        let myArray = [...this.state.businessImpactValueArray];
        const groupedData = myArray.reduce((accumulator, currentValue) => {
            const impactType = currentValue.impactType;
            const monetizableType = currentValue.monetizableType;
            const fteValue = parseFloat(currentValue.fteValue) || 0.0;
            const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;

            const existingRow = accumulator.find(row => row.impactType === impactType && row.monetizableType === monetizableType);
            if (existingRow) {
                existingRow.fteValue += fteValue
                existingRow.dollarValue += dollarValue
            } else {
                accumulator.push({ impactType, monetizableType, fteValue, dollarValue });
            }
            return accumulator;
        }, []);
        this.setState({ summaryArray: groupedData }, () => { });
        this.setState({ businessImpactValueArray: this.state.businessImpactValueArray }, () => { })
        this.setState({ isFpnaRequired: false }, () => { })
        this.state.businessImpactValueArray && this.state.businessImpactValueArray.map((item) => {
            if (item.ImpactType === "Impact at Genpact") {
                if (item.MonetizableType === "Increase in Revenue" || item.MonetizableType === "Reduction in Cost") {
                    this.setState({ isFpnaRequired: true }, () => { })
                }
            }
        })
    }

    pull_data = ({ businessImpactValueArray, dollarTotal, fteTotal }) => {
        console.log("bi recieved in pull data function", businessImpactValueArray)
        if (businessImpactValueArray) {
            this.setState({ businessImpactValueArray: businessImpactValueArray }, () => {
                this.newBusinessImpactSummary()
            }, () => { console.log("from pull data function", this.state.businessImpactValueArray) })
        }
        if (dollarTotal) {
            this.setState({ finalImpactDollar: dollarTotal }, () => { })
        }
        if (fteTotal) {
            this.setState({ finalImpactFTE: fteTotal }, () => { })
        }
    }
    pull_data_for_delete = ({ businessImpactValueArray, dollarTotal, fteValue }) => {
        console.log("fte total abc", fteValue)
        console.log("bi recieved in pull data function", businessImpactValueArray)
        if (businessImpactValueArray) {
            this.setState({ businessImpactValueArray: businessImpactValueArray }, () => {
                this.newBusinessImpactSummary()
            })

        }
        if (dollarTotal) {
            this.setState({ finalImpactDollar: dollarTotal }, () => {
                console.log("inside call back function $ total", this.state.finalImpactDollar)
            })
        }
        if (fteValue) {
            this.setState({ finalImpactFTE: fteValue }, () => {
                console.log("inside call back function fte value", this.state.finalImpactFTE)
            })
        }

    }
    pull_file_data = ({ fileName, fileType, fileContent, showClientApprovalFields, FPnAOHRMonetization }) => {
        if (fileName) {
            this.setState({ FPnAFileNameMonetization: fileName }, () => { })
        }
        if (fileType) {
            this.setState({ FPnAFileTypeMonetization: fileType }, () => { })
        }
        if (fileContent) {
            this.setState({ FPnAFileMonetization: fileContent }, () => { })
        }
        this.setState({ showClientApprovalFields: showClientApprovalFields }, () => { })
        this.setState({ FPnAOHRMonetization: FPnAOHRMonetization }, () => {
            console.log("ohr from pull_file_data function =>", this.state.FPnAOHRMonetization)
        })
    }
    remove_bi_data_after_delete = (filteredIdeaArray) => {
        console.log("bi recieved in pull data for delete function", filteredIdeaArray)
        if (filteredIdeaArray) {
            this.setState({ businessImpactValueArray: filteredIdeaArray }, () => {
                this.newBusinessImpactSummary()
                let dollarTotal = 0.0;
                let fteValue = 0.0;
                this.state.businessImpactValueArray.map((item) => {
                    if (item && item.DollarImpact) {
                        dollarTotal += parseFloat(item.DollarImpact);
                    }
                    if (item && item.dollarValue) {
                        dollarTotal += parseFloat(item.dollarValue);
                    }
                    if (item && item.FTEImpact) {
                        fteValue += parseFloat(item.FTEImpact)
                    }
                    if (item && item.fteValue) {
                        fteValue += parseFloat(item.fteValue)
                    }
                })
                this.setState({ finalImpactDollar: dollarTotal }, () => {
                    console.log("inside call back function $ total", this.state.finalImpactDollar)
                })
                this.setState({ finalImpactFTE: fteValue }, () => {
                    console.log("inside call back function fte value", this.state.finalImpactFTE)
                })

            })
        }

    }

    pull_monetization_sowId = (localSowId) => {
        this.setState({ SowID: localSowId }, () => { console.log("sow id from pull_monetization_sowId function =>", this.state.SowID) })
    }
    pull_monetization_fpna_name = (localFpnaName) => {
        console.log("fpna name from pull file function => ", localFpnaName)
        this.setState({ FPnANameMonetization: localFpnaName }, () => {
            console.log("fpna name from pull_file_function", this.state.FPnANameMonetization)
        })
    }
    pull_monetization_fpna_ohr = (localFpnaohr) => {
        console.log("fpna ohr from pull function => ", localFpnaohr)
        this.setState({ FPnAOHRMonetization: localFpnaohr }, () => { })
    }
    pull_monetizedTotal = ({ fteValue, dollarValue }) => {
        if (fteValue) {
            this.setState({ totalMonetizedDollar: fteValue }, () => {
                console.log(this.state.totalMonetizedDollar)
            })
        }
        if (dollarValue) {
            this.setState({ totalMonetizedFTE: dollarValue }, () => {
                console.log(this.state.totalMonetizedFTE)
            })
        }
    }
    pull_monetizableProject = (e) => {
        if (e) {
            this.setState({ monetizableProjectSelectedOption: e }, () => {
                console.log("monetization project Option =>", this.state.monetizableProjectSelectedOption)
            })

        }
    }
    pull_monetizableStatus = (e) => {
        if (e) {
            this.setState({ monetizationStatusSelectedOption: e }, () => {
                console.log("monetization Status SelectedOption =>", this.state.monetizationStatusSelectedOption)
            })

        }
    }

    handleVDTypeChange = (e) => {
        if (e) {
            this.setState({ impactOptionSelected: e }, () => {
                console.log("impact selected option is from review idea page", this.state.impactOptionSelected)
            })
        }
    }
    fetchFPAOHRforIncreaseInRevenue = (e) => {
        if (e === true) {
            this.setState({ appropriateAttachment: true }, () => { })
        } else {
            this.setState({ appropriateAttachment: false }, () => { })
        }
    }

    pullMonetizationGOLName = (localGOLName) => {
        this.setState({ golMonetizationName: localGOLName }, () => {
            //console.log(this.state.golMonetizationName)
        })
    }
    pullMonetizationGOLOhr = (localGOLOhr) => {
        this.setState({ golMonetizationOhr: localGOLOhr }, () => {
            console.log(this.state.golMonetizationOhr)
        })
    }
    pullCategoryNotListed = (localShowHref) => {
        this.setState({ showHrefModal: localShowHref }, () => {
            console.log("hrf modal =>", this.state.showHrefModal)
        });
    };


    // function for FPNAGOL component starts here

    // ppt deck file details
    pullPPTDeck = (fileName, fileType, fileContent) => {
        this.setState({ filename1: fileName, fileType1: fileType, base64File1: fileContent }, () => {
            //console.log("filename ",this.state.filename1, "file type ",this.state.fileType1, "content ",this.state.base64File1)
        })
    }
    pullClientDocName = (fileName) => {
        this.setState({ signOffFilename: fileName, }, () => {
            //console.log("client approval name =>",this.state.signOffFilename)
        })
    }
    pullClientDocType = (fileType) => {
        if (fileType) {
            this.setState({ signOffFileType: fileType }, () => {
                //console.log("client approval type =>",this.state.signOffFileType)
            })
        }
    }
    pullClientDocContent = (fileContent) => {
        if (fileContent) {
            this.setState({ signOffContent: fileContent }, () => {
                //console.log("client approval contnet =>",this.state.signOffContent)
            })
        }
    }

    // gol file details
    pullgolFileName = (fileName) => {
        this.setState({ filename3: fileName }, () => {
            //console.log("gol approval doc name",this.state.filename3)      
        })
    }
    pullgolFileType = (fileType) => {
        this.setState({ fileType3: fileType }, () => {
            //console.log("gol approval doc type",this.state.fileType3)      
        })
    }
    pullgolContent = (fileContent) => {
        this.setState({ base64File3: fileContent }, () => {
            //console.log("gol approval doc content",this.state.base64File3)      
        })
    }

    // fpna file details
    pullfpnafileName = (fileName) => {
        if (fileName) {
            this.setState({ filename4: fileName }, () => {
                //console.log("fpna doc name",this.state.filename4)
            })
        }
    }
    pullfpnafileType = (fileType) => {
        if (fileType) {
            this.setState({ fileType4: fileType }, () => {
                //console.log("fpna doc type",this.state.fileType4)
            })
        }
    }
    pullfpnafileContent = (fileContent) => {
        if (fileContent) {
            this.setState({ base64File4: fileContent }, () => {
                //console.log("fpna doc file content",this.state.base64File4)
            })
        }
    }

    pullClientName = (e) => {
        if (e) {
            this.setState({ clientName: e }, () => {
                //console.log(this.state.clientName)
            })
        }
    }
    pullClientRole = (e) => {
        if (e) {
            this.setState({ clientRole: e }, () => {
                //console.log(this.state.clientRole)
            })
        }
    }
    pullClientSignOff = (e) => {
        if (e) {
            this.setState({ clientSignOffDate: e }, () => {
                //console.log(this.state.clientSignOffDate)
            })
        }
    }
    pullFpnaName = (name) => {
        if (name) {
            this.setState({ fpnaName: name }, () => {
                //console.log(this.state.fpnaName)
            })
        }

    }
    pullGolName = (name) => {
        if (name) {
            this.setState({ golFullname: name }, () => {
                //console.log(this.state.golFullname)
            })
        }

    }
    pullFpnaOhr = (e) => {
        if (e) {
            this.setState({ fpnaOhr: e }, () => {
                //console.log(this.state.fpnaOhr)
            })
        }
    }
    pullGolOhr = (e) => {
        if (e) {
            this.setState({ golOhr: e }, () => {
                //console.log(this.state.golOhr)
            })
        }
    }
    pull_fileDetails = (obj) => {
        this.setState({ golFpnaFileDetails: obj }, () => {
            //console.log(this.state.golFpnaFileDetails)
        })
    }

    // function for FPNAGOL component ends here

    render() {
        let IDEA_APPROVED = (this.state.ideaItem.WorkflowStatus === "Approve");
        let IDEA_REJECTED = (this.state.ideaItem.WorkflowStatus === "Reject");
        let IDEA_SEND_BACK = (this.state.ideaItem.WorkflowStatus === "Send Back");
        // let redirectURL = "/review-page";
        // if( this.state.approvalPage) {
        //     redirectURL = redirectURL + "?page=approval";
        // }
        let IsSolnFeasibleValue = "";
        if (this.state.ideasAI) {
            if (this.state.ideasAI.IsSolnFeasible === false || this.state.ideasAI.IsSolnFeasible === 0 || this.state.ideasAI.IsSolnFeasible === "0") {
                IsSolnFeasibleValue = "No"
            }
            if (this.state.ideasAI.IsSolnFeasible === true || this.state.ideasAI.IsSolnFeasible === 1 || this.state.ideasAI.IsSolnFeasible === "1") {
                IsSolnFeasibleValue = "Yes"
            }
        }

        return (
            <section className="u-clearfix u-section-1" id="sec-0f7f">
                <div className="u-clearfix u-sheet u-sheet-1" style={{ marginBottom: 20 }}>
                    <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
                        <div className="u-container-layout u-container-layout-1">
                            <h4 style={{ textAlign: 'center', color: '#00AECF', fontFamily: 'Arial', fontSize: 22 }}>MBB Review idea : {this.state.ideaItem.IdeaIDAlpha ? this.state.ideaItem.IdeaIDAlpha : this.state.ideaItem.IdeaId} </h4>
                            <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                                <div className="u-container-layout u-container-layout-2" style={{ textAlign: 'center' }}>
                                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                                        <div className="u-container-layout u-container-layout-3">
                                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 15 }}>Owner details </p>
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Owner OHR</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.OwnerOHR} /></div>
                                            </div>
                                            <div style={{ marginBottom: 15 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Owner Name</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.OwnerName} /></div>
                                            </div>
                                            <div style={{ marginBottom: -10 }} />
                                            <p className="u-align-left u-text u-text-7 u-text-custom-color-3" style={{ fontSize: 11, marginBottom: 10 }}>(If Idea was raised for someone else, their OHR ID is below)</p>
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Request For OHR</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.CreatorOHR} onChange={this.handleCreatorOHRChange} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Name</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.CreatorName} onChange={this.handleCreatorNameChange} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Project ID</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.LeanID} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                        </div>
                                    </div>

                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 235 }}>&nbsp;</p>

                                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4" style={{ marginTop: "-305px" }}>
                                        <div className="" style={{ display: "flex", marginTop: '30px' }}>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-5">
                                                <div className="u-container-layout u-container-layout-5">
                                                    <p className="u-align-left u-text u-text-8" style={{ marginBottom: 15 }}>Account Details</p>
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Account&nbsp;Name</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="accounts" name="accounts" placeholder="Choose Account" value={this.state.ideaItem.AccountManual} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Holding&nbsp;Account</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled type="text" value={this.state.ideaItem.HoldingAccount} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Vertical</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="vertical" placeholder="Choose Vertical" value={this.state.ideaItem.VerticalManual} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Industry&nbsp;Vertical</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="subverticallist" placeholder="Choose Industry&nbsp;Vertical" value={this.state.ideaItem.SubVerticalName} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />

                                                    {/* units and segments starts here */}
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Segment</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="segment" value={this.state.ideaItem.Segment ? this.state.ideaItem.Segment : ""} style={{ fontWeight: 'normal !important' }} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Unit</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="unit" value={this.state.ideaItem.Unit ? this.state.ideaItem.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    {/* units and segments ends here */}


                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Campaign&nbsp;Name</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disa
                                                                bled name="ideationtype" placeholder="Choose Idea Type" value={this.state.ideaItem.CampaignName} />
                                                        </div>
                                                        <div className="">
                                                            <div className="campaign_modal_bulb campaign_tool_tip">
                                                                <img
                                                                    src={require("../assets/images/question_mark_2.png")}
                                                                    alt=""
                                                                    className=""
                                                                />
                                                                {
                                                                    this.state.campaignInsight
                                                                        ?
                                                                        <>
                                                                            <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />

                                                    {
                                                        this.state.ideaItem.SubCampaignName && (
                                                            <div className="row" style={{ marginBottom: 15 }}>
                                                                <div className="col-md-5" >
                                                                    {
                                                                        this.state.ideaItem.CampaignName === "Gen AI"
                                                                            ?
                                                                            <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Gen AI Theme</label>
                                                                            :
                                                                            <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub Campaign</label>

                                                                    }
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input
                                                                        className="form-input"
                                                                        disabled
                                                                        list="subcampaign"
                                                                        name="subcampaign"
                                                                        placeholder="Sub Campaign"
                                                                        value={this.state.ideaItem.SubCampaignName}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    
                                                    {
                                                        this.state.ideaItem.DataBridgeTheme && (
                                                            <>
                                                                <div className="row" style={{ marginBottom: 15 }}>
                                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Data Bridge Project Theme</label></div>
                                                                    <div className="col-md-7">
                                                                        <input className="form-input" disabled list="databridgetype" name="databridgetype" placeholder="Choose Data Bridge Project Type" value={this.state.ideaItem.DataBridgeTheme} />
                                                                    </div>
                                                                </div>
                                                                <div  />
                                                                <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginBottom: 30 }}>&nbsp;</p>
                                                            </>
                                                        )
                                                    }
                                                    


                                                    {
                                                        this.state.displayParentAlpha && this.state.displayParentAlpha.length > 0 && this.state.displayParentAlpha !== null && this.state.displayParentAlpha !== undefined && this.state.displayParentAlpha !== ""
                                                            ?
                                                            <>
                                                                <div className="row" style={{ marginBottom: 15 }}>
                                                                    <div className="col-md-5">
                                                                        <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Parent ID</label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <input className="form-input" disabled placeholder="Choose Parent ID" value={this.state.displayParentAlpha} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }


                                                    {
                                                        this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                                            ?
                                                            <>
                                                                <div className="row" style={{ marginBottom: 15 }}>
                                                                    <div className="col-md-5">
                                                                        <label
                                                                            style={{
                                                                                verticalAlign: "bottom",
                                                                                marginBottom: -5,
                                                                            }}
                                                                        >
                                                                            <i>AI First Sample Ideas</i>
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                                                            <a
                                                                                className="ldt-list1"
                                                                                href={AI_DOC_LINK}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                                                            >Document Link </a>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                {
                                                                    this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                        ?
                                                                        <>
                                                                            <div style={{ marginBottom: 20 }} />
                                                                            <div className="row d_flex_align_items_center">
                                                                                <div className="col-md-5">
                                                                                    <span className="form-attribute">
                                                                                        AI Recommendation
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <input
                                                                                        className="form-input"
                                                                                        disabled
                                                                                        name="methodology"
                                                                                        value={this.state.ideaItem.isAI}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null

                                                                }


                                                                {
                                                                    this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                        ?
                                                                        <>
                                                                            <div style={{ marginBottom: 20 }} />
                                                                            <div className="row">
                                                                                <div className="col-md-5">
                                                                                    <span className="form-attribute">
                                                                                        AI First BRD
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <div className="ai_first_doc_link">
                                                                                        <textarea className="ai_first_brd_textarea" disabled value={this.state.ideasAI.LinkBRD} ></textarea>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }

                                                            </>
                                                            :
                                                            null
                                                    }
                                                    
                                                </div>
                                            </div>
                                            <div className="u-container-layout u-container-layout-6">
                                                <div className="row" style={{ marginTop: "10px" }}>
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Country</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled name="regions" placeholder="Choose Country" value={this.state.ideaItem.Country} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Region</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled name="regions" placeholder="Choose Region" value={this.state.ideaItem.RegionManual} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub-Region</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled name="regions" placeholder="Choose Sub-Region" value={this.state.ideaItem.SubRegion} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Blackbelt&nbsp;Name</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled name="blackbelt" placeholder="Choose Blackbelt" title={"OHR ID: " + this.state.ideaItem.BlackBeltUserId} value={this.state.ideaItem.BlackBeltUserName} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>MBB</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled name="blackbelt" placeholder="Choose MBB" title={"OHR ID: " + this.state.ideaItem.MBBOHR} value={this.state.ideaItem.MBBName} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                {/* <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>LDA</label></div>
                                                    <div className="col-md-7">
                                                        <input className ="form-input" disabled name="blackbelt" placeholder="Choose LDA" title={"OHR ID: " +  this.state.ideaItem.LDAOHR} value={this.state.ideaItem.LDA} />
                                                    </div>
                                                </div> */}

                                                {
                                                    this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST &&
                                                        this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                        ?
                                                        <>
                                                            <div style={{ marginBottom: 20 }} />
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <span className="form-attribute">
                                                                        AI First Reason
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <textarea
                                                                        disabled
                                                                        value={this.state.ideasAI.AIReason}
                                                                        placeholder="Please provide value"
                                                                        className="form-input"
                                                                        rows={4}
                                                                        cols={80}
                                                                        style={{
                                                                            width: "100%",
                                                                            border: "1px solid lightgrey",
                                                                            resize: "none"
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 20 }} />
                                                        </>
                                                        :
                                                        null
                                                }


                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ borderBottom: '1px solid lightgrey', marginBottom: 15 }} />

                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: -30 }}>&nbsp;</p>

                                    <div id="idea1" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ marginTop: 15 }}>
                                        <div className="u-container-layout u-container-layout-7">
                                            <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                <div className="u-container-layout u-container-layout-8">
                                                    <p id="idea1title" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Idea details</p>
                                                    <div className="row">
                                                        <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Service Line</label> </div>
                                                        <div className="col-md-8">
                                                            <input className="form-input" disabled name="serviceline" placeholder="Choose Service Line" value={this.state.ideaItem.ServiceLineName} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub Service Line</label> </div>
                                                        <div className="col-md-8">
                                                            <input className="form-input" disabled name="serviceline" placeholder="Choose Sub Service Line" value={this.state.ideaItem.SubServiceLine} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                        <span className="u-text-black form-attribute"> What is the Problem ?</span>&nbsp;
                                                    </p>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <textarea className="form-input" disabled rows={6} cols={80} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} value={this.state.ideaItem.Problem} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-9">
                                                <div className="u-container-layout u-container-layout-9" style={{ marginTop: 4 }}>
                                                    <div className="row">
                                                        <div className="col-md-3"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Idea Name</label> </div>
                                                        <div className="col-md-9" style={{ alignItems: 'flex-start' }}><input className="form-input" disabled type="text" value={this.state.ideaItem.IdeaName} placeholder="Eg: Cash flow improvement through process restructuring" /></div>
                                                    </div>
                                                    <div style={{ marginBottom: 66 }} />
                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25" style={{ width: "177px" }}>
                                                        <span className="u-text-black form-attribute"> How to resolve the problem</span>&nbsp;
                                                    </p>
                                                    <div className="row" style={{ marginBottom: 15 }}>
                                                        <div className="col-md-12">
                                                            <textarea className="form-input" disabled rows={6} cols={80} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} value={this.state.ideaItem.Solution} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ marginTop: 15 }}>
                                                <div className="col-md-5"><span className="form-attribute">Are you trying to replicate an existing Idea?</span>

                                                </div>
                                                <div className="col-md-4">
                                                    <label className="switch">
                                                        <input disabled type="checkbox" checked={this.state.ideaItem.NewOrReplicatedIdea === null ? false : this.state.ideaItem.NewOrReplicatedIdea} />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>

                                            {
                                                this.state.ideaItem.NewOrReplicatedIdea && (
                                                    <>
                                                        <div className="col-md-8" style={{ marginBottom: 15, width: "100%" }} />
                                                        <div className="row">
                                                            <div className="col-md-5"><span className="form-attribute">Provide the ID of the executed Idea which you want to replicate?</span>
                                                            </div>
                                                            <div className="col-md-2"><input className="form-input" disabled type="text" value={this.state.ideaItem.ReplicationProjectId} /></div>
                                                        </div>
                                                    </>
                                                )
                                            }

                                            <div className="col-md-8" style={{ marginBottom: 15 }} />
                                        </div>
                                    </div>

                                    {
                                        (this.state.ideaItem.WorkflowStatus && this.state.ideaItem.WorkflowStatus !== "Pending") && (
                                            <>
                                                <div style={{ borderBottom: '1px solid lightgrey', marginBottom: 15 }} />
                                                <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                    <div className="u-container-layout u-container-layout-7">
                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Idea Approval details</p>
                                                        <div className="row">
                                                            <div className="col-md-2"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Approval Status</label></div>
                                                            <div className="col-md-2">
                                                                <input className="form-input" disabled name="Status" value={IDEA_APPROVED ? APPROVED : (IDEA_REJECTED ? REJECTED : (IDEA_SEND_BACK ? SENT_BACK : PENDING))} />
                                                            </div>
                                                            {/* <div className="col-md-3"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Expected timeline for execution</label></div>
                                                        <div className="col-md-2">
                                                            <input disabled name="ExpectedDate" value={this.state.ideaItem.ExpectedFinishDate ? this.formatDateString(new Date(this.state.ideaItem.ExpectedFinishDate)): ""} />
                                                        </div> */}
                                                        </div>
                                                        <div className="row" style={{ marginTop: 15 }}>
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Comments</label></div>
                                                            <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ commentLog: !this.state.commentLog })}>Comment Log</button>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 5 }}>
                                                            <div className="col-md-12">
                                                                <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.Comment} />
                                                            </div>
                                                        </div>
                                                        <div className="text-left mt-4">
                                                            {
                                                                this.state.commentLog && this.state.reviewComments
                                                                    ?
                                                                    <>
                                                                        <div className="custom_modal">
                                                                            <div className="modal_body">
                                                                                <div className="row">
                                                                                    <div className="col-md-8">
                                                                                        <h3 className="modal_title">Idea Approval Comment Log</h3>
                                                                                    </div>
                                                                                    <div className="col-md-4">
                                                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ commentLog: false })}>&times;</button>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                    </div>
                                                                                    <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                    </div>
                                                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    this.state.reviewComments.map((item, index) => {

                                                                                        return (
                                                                                            <div className="row" key={index}>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                </div>
                                                                                                <div className="col-md-1 text-center role_over_flow_class" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === 'Delegate Action' ? 'BB' : (item.UpdaterOHR === this.state.ideaItem.BlackBeltUserId ? "BB" : (item.UpdaterOHR === this.state.ideaItem.MBBOHR ? "MBB" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Owner" : item.UpdaterRole))))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.Action === 'Idea Reinitiated by Admin' ? 'Idea Reinitiated' : (item.Action === 'Idea Updated by Admin' ? (item.WorkflowStatus !== 'Pending' ? item.WorkflowStatus : 'Idea Updated') : (item.Action === 'Delegate Action' ? 'Delegated' : (item.WorkflowStatus === 'Pending' ? 'Reject Cancellation' : item.WorkflowStatus)))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment ? item.Comment : '-'}</label>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        {/* <div className="col-md-9" style={{ marginBottom: 5, width: '100%' }} />
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                                <span className="u-text-black form-attribute">Comments</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.Comment} />
                                                        </div>
                                                    </div> */}
                                                    </div>
                                                </div>
                                                <div style={{ borderBottom: '1px solid lightgrey', marginBottom: 15, marginTop: 15 }} />

                                                {
                                                    (this.state.ideaItem.WorkflowStatus && (this.state.ideaItem.WorkflowStatus === "Approve" || this.state.ideaItem.WorkflowStatus === "Approved")) && (
                                                        <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ borderBottom: "1px solid lightgray", marginBottom: "10px" }}>
                                                            <div className="u-container-layout row" style={{ marginTop: "30px" }}>
                                                                <div className="col-md-5">
                                                                    <div className="u-container-layout">
                                                                        <p id="Potential Impact" className="u-align-left u-text u-text-2" style={{ marginBottom: "30px" }}>Additional details</p>
                                                                        <div className="row">
                                                                            <div className="col-md-6"><span className="form-attribute">LDT Lead Name</span></div>
                                                                            <div className="col-md-6">
                                                                                <input className="form-input" disabled list="ldtName" name="ldtName" placeholder="Choose LDT Lead" title={"OHR ID: " + this.state.ideaItem.LDTId} value={this.state.ideaItem.LDTLeadName} />
                                                                            </div>
                                                                        </div>
                                                                       
                                                                        <div style={{ marginTop: 15 }} />
                                                                        {
                                                                            this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                                                                && this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                                ?
                                                                                <>
                                                                                    <div style={{ marginBottom: 15 }} />
                                                                                    <div className="row d_flex_align_items_center">
                                                                                        <div className="col-md-6">
                                                                                            <span className="form-attribute">
                                                                                                Is the solution feasible ?
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-md-6">
                                                                                            <input
                                                                                                className="form-input"
                                                                                                disabled
                                                                                                value={IsSolnFeasibleValue}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ marginBottom: 15 }} />
                                                                                    <div className="row d_flex_align_items_center">
                                                                                        <div className="col-md-6">
                                                                                            <span className="form-attribute">
                                                                                                Solution Complexity
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-md-6">
                                                                                            <input
                                                                                                className="form-input"
                                                                                                disabled
                                                                                                name="methodology"
                                                                                                value={
                                                                                                    this.state.ideasAI.SolnComplexity
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    </div>


                                                                                    <div style={{ marginBottom: 15 }} />
                                                                                    <div className="row d_flex_align_items_center">
                                                                                        <div className="col-md-6">
                                                                                            <span className="form-attribute">
                                                                                                Is the Idea replicable
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-md-6">
                                                                                            <input
                                                                                                className="form-input"
                                                                                                disabled
                                                                                                value={this.state.isIdeaReplicable}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ marginBottom: 15 }} />
                                                                                </>
                                                                                :
                                                                                null
                                                                        }
                                                                        {
                                                                            this.state.ideaItem.NewOrReplicatedIdea && (
                                                                                <div className="row">
                                                                                    <div className="col-md-10">
                                                                                        <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}><span style={{ color: 'red' }}>*</span> Have you verified the replication id and confirm this to be replication project?</label>
                                                                                    </div>
                                                                                    <div className="col-md-2">
                                                                                        <label className="switch">
                                                                                            <input disabled type="checkbox" checked={this.state.ideaItem.IsReplicationVerified} />
                                                                                            <span className="slider round" />
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }

                                                                        {
                                                                            this.state.CodersTable && this.state.CodersTable.length>0
                                                                                ?
                                                                                <div className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                                                    <div className="u-container-layout u-container-layout-7" style={{ paddingTop: "40px" }}>
                                                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Coder Section</p>
                                                                                        <div className="VD_Summary" >
                                                                                            <div className="row mt-3">
                                                                                                <div className="col-md-7 col-xs-4 VD_Summary_table_header">
                                                                                                    <div className=""><label>Coder Name</label></div>
                                                                                                </div>
                                                                                                <div className="col-md-3 col-xs-4 VD_Summary_table_header">
                                                                                                    <div><label>Coder OHR</label></div>
                                                                                                </div>
                                                                                            </div>
                                                                                            {this.state.CodersTable && this.state.CodersTable.map((item, index) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        <div className="" key={index}>
                                                                                                            <div className="row">
                                                                                                                <div className="col-md-7 col-xs-4 VD_Summary_table_row">
                                                                                                                    <div style={{ marginTop: '2.5px' }}>
                                                                                                                        <label>{item.OHRName}</label>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="col-md-3   col-xs-4 VD_Summary_table_row">
                                                                                                                    <div style={{ marginTop: '2.5px' }}>
                                                                                                                        <label>{item.OHR}</label>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </>
                                                                                                )
                                                                                            })}
                                                                                        </div>
                                                                                        <div className="col-md-12" style={{ marginBottom: "15px" }} />
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>
                                                                </div>


                                                                <div className="col-md-3"></div>
                                                                <div className="col-md-4">
                                                                    <div className="" >
                                                                        <div className="row">
                                                                            <div className="col-md-5"><span className="form-attribute">Certification Level</span> </div>
                                                                            <div className="col-md-7">
                                                                                <input className="form-input" disabled name="certlevel" value={this.state.ideaItem.CertificationLevelName} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="row">
                                                                            <div className="col-md-5"><span className="form-attribute">Transformation Lever</span> </div>
                                                                            <div className="col-md-7">
                                                                                <input className="form-input" disabled name="translever" value={this.state.ideaItem.TransformationLeverName} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        {
                                                                            this.state.ideaItem.TransformationLeverName === "Digital" && (
                                                                                <>
                                                                                    <div className="row">
                                                                                        <div className="col-md-5"><span className="form-attribute">Digital Project Type</span> </div>
                                                                                        <div className="col-md-7">
                                                                                            <input className="form-input" disabled name="translever" value={this.state.ideaItem.DigitalProjectType} />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ marginBottom: 15 }} />
                                                                                </>
                                                                            )
                                                                        }
                                                                        


                                                                        {this.state.ideaItem.AIClassification
                                                                            ?
                                                                            <>
                                                                                <div className="row">
                                                                                    <div className="col-md-5">
                                                                                        <span className="form-attribute">
                                                                                            AI Classification
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-md-7">
                                                                                        <input
                                                                                            placeholder="AI Classification"
                                                                                            title={this.state.ideaItem.AIClassification}
                                                                                            className="form-input"
                                                                                            disabled
                                                                                            name="ai classification"
                                                                                            value={this.state.ideaItem.AIClassification}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ marginBottom: 15 }} />
                                                                            </>
                                                                            :
                                                                            null
                                                                        }

                                                                        <div className="row">
                                                                            <div className="col-md-5"><span className="form-attribute">Tools/Methodology Used</span></div>
                                                                            <div className="col-md-7">
                                                                                <textarea className="form-input" disabled value={this.state.methodologies} title={this.state.methodologies} list="methodology" name="methodology" placeholder="Tools/Methodology" style={{ width: "100%" }} />
                                                                            </div>
                                                                        </div>

                                                                        <div style={{ marginBottom: 10 }} />
                                                                        {
                                                                            this.state.ideaItem.OtherTools
                                                                                ?
                                                                                <>
                                                                                    <div className="row">
                                                                                        <div className="col-md-5">
                                                                                            <span className="form-attribute">Other tools</span>
                                                                                        </div>
                                                                                        <div className="col-md-7">
                                                                                            <textarea
                                                                                                title={this.state.ideaItem.OtherTools}
                                                                                                className="form-input"
                                                                                                disabled
                                                                                                placeholder="Other tools value"
                                                                                                name="othertools"
                                                                                                value={this.state.ideaItem.OtherTools}
                                                                                                style={{ width: "100%", overflowY: "scroll" }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                                :
                                                                                null
                                                                        }

                                                                        <div style={{ marginBottom: 5 }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    

                                    {/* Final Approval Section  */}
                                    {
                                        (this.state.ideaItem.ApprovalStatus
                                            && this.state.ideaItem.ApprovalStatus !== "NA"
                                            && this.state.ideaItem.ApprovalStatus !== "Pending Documents"
                                            && this.state.ideaItem.ApprovalStatus !== "Documents Uploaded"
                                        )
                                        && (
                                            <>
                                                <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                    <div className="u-container-layout u-container-layout-7">
                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Lean Approval details</p>
                                                        <div className="row">
                                                            <div className="col-md-2"><span className="form-attribute">Approval Status</span> </div>
                                                            <div className="col-md-2">
                                                                <input className="form-input" disabled name="finalapprovalstatus" value={this.state.ideaItem.ApprovalStatus} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 15 }}>
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Approval Comments</label></div>
                                                            <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ finalCommentLog: !this.state.finalCommentLog })}>Comment Log</button>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 5 }}>
                                                            <div className="col-md-12">

                                                                {/* <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.FinalComments} /> */}
                                                                <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.lastFinalComment} />
                                                            </div>
                                                        </div>
                                                        <div className="text-left mt-4">
                                                            {
                                                                this.state.finalCommentLog && this.state.finalReviewComments
                                                                    ?
                                                                    <>
                                                                        <div className="custom_modal">
                                                                            <div className="modal_body">
                                                                                <div className="row">
                                                                                    <div className="col-md-8">
                                                                                        <h3 className="modal_title">Lean Approval Comment Log</h3>
                                                                                    </div>
                                                                                    <div className="col-md-4">
                                                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ finalCommentLog: false })}>&times;</button>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                    </div>
                                                                                    <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                    </div>
                                                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    this.state.finalReviewComments.map((item, index) => {

                                                                                        return (
                                                                                            <div className="row" key={index}>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                </div>
                                                                                                <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === 'Idea was reviewed by MBB' ? "MBB" : (item.Action === 'Idea was reviewed by LDT' ? "LDT" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Owner" : "BB")))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.Action === 'Idea Reinitiated by Admin' ? 'Idea Reinitiated' : (item.Action === 'Idea Updated by Admin' ? item.ApprovalStatus : (item.WorkflowStatus === COMPLETE_STATUS || item.WorkflowStatus === 'Approve' || item.WorkflowStatus === 'Approved' || item.ApprovalStatus === AWAITING_QAULITY_CHECK_REVIEW) ? 'Approved' : ((item.WorkflowStatus === 'Rejected' || item.WorkflowStatus === 'Reject') ? "Rejected" : (item.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION ? AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION : (item.WorkflowStatus === 'Pending Documents' ? 'Reject Cancellation' : item.WorkflowStatus === CANCEL ? CANCEL : "Sent Back"))))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment ? item.Comment : '-'}</label>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    (this.state.ideaItem.ApprovalStatus && (this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS || this.state.ideaItem.ApprovalStatus === AWAITING_MASTER_BLACKBELT_APPROVAL || this.state.ideaItem.ApprovalStatus === AWAITING_QAULITY_CHECK_REVIEW)) && (
                                                        <>
                                                            <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                                <div className="u-container-layout u-container-layout-7" style={{ borderTop: "1px solid lightgray", borderBottom: "1px solid lightgray", padding: "40px 30px 4px 0px", marginBottom: "15px" }}>
                                                                    <p id="Potential Impact" className="u-align-left u-text u-text-2" style={{ marginBottom: "20px" }}>Final additional details</p>
                                                                    <div className="row pb-4">
                                                                        <div className="col-md-6">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <span className="form-attribute">Best in Class</span>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <label className="switch">
                                                                                        <input disabled type="checkbox"
                                                                                            checked={this.state.ideaItem.IsBestInClass === null ? false : this.state.ideaItem.IsBestInClass}
                                                                                        />
                                                                                        <span className="slider round" />
                                                                                    </label>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            {
                                                                                this.state.ideaItem.ReplicabilityIndex !== null && (
                                                                                    <div className="row">
                                                                                        <div className="col-md-6">
                                                                                            <span className="form-attribute">Replicability Index</span>
                                                                                        </div>
                                                                                        <div className="col-md-6">
                                                                                            <input className="form-input" disabled value={this.state.replicabilityIndex && this.state.replicabilityIndex.label} />
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    {
                                        this.state.ideaItem.VDType === "No Value Delivery"
                                            ?
                                            <>
                                                <div className="no_value_delivery_border"></div>
                                            </>
                                            :
                                            null
                                    }

                                    {
                                        this.state.ideaItem.IdeaId && this.state.ideaItem.VDType 
                                            ?
                                            <>
                                                <ValueDelivery 
                                                    IdeaData = {this.state.ideaItem}
                                                    vdForComponent={this.state.vdForComponent}
                                                    BIMasterDataVerseNew={[]}
                                                    func={this.pull_data} 
                                                    viewIdea={true}
                                                    vdType={this.handleVDTypeChange}
                                                    IdeaId={this.state.ideaItem.IdeaId}
                                                    fetchMonetizationFileDetails={this.pull_file_data}
                                                    fetchMonetizationFpnaName={this.pull_monetization_fpna_name}
                                                    fetchMonetizationFpnaOhr={this.pull_monetization_fpna_ohr}
                                                    fetchMonetizationSowID={this.pull_monetization_sowId}
                                                    bbMonetizationTotal={this.pull_monetizedTotal}
                                                    monetizableProject={this.pull_monetizableProject}
                                                    monetizableStatus={this.pull_monetizableStatus}
                                                    fetchFPAOHRforIncreaseInRevenue={this.fetchFPAOHRforIncreaseInRevenue}
                                                    bbMonetizationApproval={false}
                                                    postFpnaValid={true}
                                                    fetchDeletedBIRows={this.remove_bi_data_after_delete}
                                                    fetchMonetizationGOLName={this.pullMonetizationGOLName}
                                                    fetchMonetizationGOLOhr={this.pullMonetizationGOLOhr}
                                                    fetchCategoryNotListed={this.pullCategoryNotListed}

                                                    fetchPPTDeck={this.pullPPTDeck}
                                                    fetchClientDocName={this.pullClientDocName}
                                                    fetchClientDocType={this.pullClientDocType}
                                                    fetchClientDocContent={this.pullClientDocContent}
                                                    fetchGolDocName={this.pullgolFileName}
                                                    fetchGolDocType={this.pullgolFileType}
                                                    fetchGolDocContent={this.pullgolContent}
                                                    fetchfpnaDocName={this.pullfpnafileName}
                                                    fetchfpnaDocType={this.pullfpnafileType}
                                                    fetchfpnaDocContent={this.pullfpnafileContent}
                                                    fetchClientName={this.pullClientName}
                                                    fetchClientRole={this.pullClientRole}
                                                    fetchClientSignOffDate={this.pullClientSignOff}
                                                    fetchFpnaName={this.pullFpnaName}
                                                    fetchGolName={this.pullGolName}
                                                    fetchFpnaOhr={this.pullFpnaOhr}
                                                    fetchGolOhr={this.pullGolOhr}
                                                    fetchFileDetails={this.pull_fileDetails}

                                                />
                                            </>
                                            :
                                            null
                                    }




                                    {/* ..........qc approval details starts here........    */}
                                    {
                                        this.state.ideaItem.QCOHR !== ""
                                            ?
                                            <>
                                                <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                    <div className="u-container-layout u-container-layout-7" style={{ margin: "10px 0px", borderBottom: "1px solid lightgray", borderTop: "1px solid lightgray", paddingTop: "35px" }}>
                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>QC Approval details</p>
                                                        <div className="row">
                                                            <div className="col-md-2"><span className="form-attribute">Approval Status</span> </div>
                                                            <div className="col-md-3">
                                                                <input className="form-input" disabled name="finalapprovalstatus" value={this.state.ideaItem.ApprovalStatus} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 15 }}>
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Approval Comments</label></div>
                                                            <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ qcCommentLog: !this.state.qcCommentLog })}>Comment Log</button>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 5 }}>
                                                            <div className="col-md-12">
                                                                <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.qcLastComment} />
                                                            </div>
                                                        </div>
                                                        <div className="text-left mt-4">
                                                            {
                                                                this.state.qcCommentLog && this.state.qcComments
                                                                    ?
                                                                    <>
                                                                        <div className="custom_modal">
                                                                            <div className="modal_body">
                                                                                <div className="row">
                                                                                    <div className="col-md-8">
                                                                                        <h3 className="modal_title">QC Comment Log</h3>
                                                                                    </div>
                                                                                    <div className="col-md-4">
                                                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ qcCommentLog: false })}>&times;</button>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="qc_responsive_comment_log">
                                                                                    <div className="table table-responsive table-bordered">
                                                                                        <thead className='text-center'>
                                                                                            <tr>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg" style={{ minWidth: "250px" }}>
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthOne">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Is the impact correctly tagged to Genpact or Client ?</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthTwo">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Has the Value Delivery been correctly categorized ?</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthThree">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Has the Value Delivery been computed correctly ?</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthFour">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period ?</label>
                                                                                                </th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                                this.state.qcComments.map((item, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === "Delegate Action" ? 'BB' : (item.UpdaterOHR === this.state.MBBOHR ? 'MBB' : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Idea Owner" : (item.ApprovalStatus === "Pending Documents" && item.WorkflowStatus === "Approved") ? "BB" : (item.ApprovalStatus === "NA" && item.WorkflowStatus === "Pending") ? "BB" : item.UpdaterRole)))}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.ApprovalStatus==="Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus==="Rejected" || item.WorkflowStatus==="Reject" || item.ApprovalStatus==="Reject" || item.ApprovalStatus==="Rejected" )? "Rejected ":"Approved")}</label> */}
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.ApprovalStatus === "Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus === "Rejected" || item.WorkflowStatus === "Reject" || item.ApprovalStatus === "Reject" || item.ApprovalStatus === "Rejected") ? "Rejected " : (item.Action === "Idea was Rework - QC" ? "Rework" : "Approved"))}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment !== '' ? item.Comment : '-'}</label>
                                                                                                            </td>
                                                                                                            {
                                                                                                                this.state.qcCommentsWithVD && this.state.qcCommentsWithVD.length > 0
                                                                                                                    ?
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            this.state.qcCommentsWithVD.map((pg_item) => {
                                                                                                                                if (Number(pg_item.ProjectTeamID) === item.TrackId) {
                                                                                                                                    return (
                                                                                                                                        <>
                                                                                                                                            <td>
                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>

                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdimpacttagged ? JSON.parse(pg_item.AuditDataJSON).pg_isvdimpacttagged : "-"}
                                                                                                                                                </label>
                                                                                                                                            </td>
                                                                                                                                            <td>

                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdcategorized ? JSON.parse(pg_item.AuditDataJSON).pg_isvdcategorized : "-"}

                                                                                                                                                </label>
                                                                                                                                            </td>
                                                                                                                                            <td>
                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdcomputed ? JSON.parse(pg_item.AuditDataJSON).pg_isvdcomputed : "-"}
                                                                                                                                                </label>
                                                                                                                                            </td>
                                                                                                                                            <td>
                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdclientsignoff ? JSON.parse(pg_item.AuditDataJSON).pg_isvdclientsignoff : "-"}
                                                                                                                                                </label>
                                                                                                                                            </td>

                                                                                                                                        </>

                                                                                                                                    )
                                                                                                                                }

                                                                                                                            })
                                                                                                                        }
                                                                                                                    </>
                                                                                                                    :
                                                                                                                    <>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                    </>
                                                                                                            }


                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            }

                                                                                        </tbody>
                                                                                    </div>
                                                                                </div>


                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="gol_fields_block">
                                                    <p className="u-align-left u-text u-text-2" style={{ margin: "10px 0px 20px" }}>Quality Check Details</p>
                                                    <div className="row u-align-left">
                                                        <div className="col-md-5">
                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Is the impact correctly tagged to Genpact or Client ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input className="form-input disabled_input" disabled value={this.state.ideaItem.IsVDImpactTagged} />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Has the Value Delivered been correctly categorized ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input className="form-input disabled_input" disabled value={this.state.ideaItem.IsVDCategorized} />
                                                                </div>
                                                            </div>

                                                            <div style={{ marginBottom: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-5 gol_field_div">
                                                                    <span className="form-attribute">Project Reviewed By</span>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input className="form-input disabled_input" disabled value={this.state.ideaItem.QCName} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2"></div>
                                                        <div className="col-md-5">
                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Has the Value Delivered been computed correctly ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input disabled value={this.state.ideaItem.IsVDComputed} className="form-input disabled_input" type="text" />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input disabled className="form-input disabled_input" type="text" value={this.state.ideaItem.IsVDClientSignOff} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            null
                                    }
                                    {/* ...........qc approval details ends here........... */}




                                    <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                        <div className="u-container-layout u-container-layout-7 " style={{ padding: "21px 0px 21px 0px" }}>
                                            <p className="u-align-left u-text u-text-2">Approval details</p>
                                            <div className="row d_flex_align_items_center">
                                                <div className="col-md-2"><span className="form-attribute"><span style={{ color: 'red' }}>*</span> Approval Status</span> </div>
                                                <div className="col-md-2">
                                                    <Select isSearchable={false} options={this.renderStatusOptions()} value={this.state.approvalSelectedOption} placeholder="Choose Status" onChange={this.handleApprovalStatus} styles={this.state.selectStyle.approvalSelectedOption} />
                                                </div>
                                            </div>
                                            <div className="col-md-8" style={{ marginBottom: 5, width: "100%" }} />
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <div className="">
                                                        <div className="row" style={{ marginTop: "9px", display: "flex", alignItems: "center", marginBottom: '10px' }}>
                                                            <div className="col-md-11">
                                                                <p className="u-align-left" style={{ margin: "0px" }}>
                                                                    <span className="u-text-black form-attribute"><span style={{ color: 'red' }}>*</span>&nbsp;Approval Comments<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>&nbsp;(max. 500 chars)</span></span>
                                                                </p>
                                                            </div>
                                                            <div className="col-md-1" style={{ display: 'flex', justifyContent: "flex-end", alignItems: "center" }}>
                                                                <img onClick={(e) => this.toggleTranscriptFunction(8)} src={require("../assets/images/voice.png")} className="w100" alt="" style={{ width: "24px", cursor: "pointer" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <textarea className="textarea-css form-attribute" style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.comment }} placeholder="Please provide your comments in support of the Approval decision."
                                                        onChange={this.handleFinalCommentChange}
                                                        rows={3} cols={88}
                                                        value={this.state.finalComment}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            this.state.speechModal
                                                ?
                                                <UpdatedSpeech modalOpen={true}
                                                    onMBBApprovalComment={this.handleTranscriptMBBComment}
                                                    modalId={this.state.modalIndex}
                                                    closeModalFunction={this.closeModalFunction}
                                                    previousText={this.state.previousTextForSpeech}
                                                />
                                                :
                                                null
                                        }
                                    </div>


                                    {this.state.showHrefModal ? (
                                        <>
                                            <div className="custom_modal href_modal">
                                                <div className="modal_body href_modal_body">
                                                    <div className="href_modal_dialog">
                                                        <p>
                                                            To add a new category please raise a Helpmate
                                                            ticket, Click here to View SOP
                                                        </p>
                                                        <div className="href_modal_body_buttons">
                                                            <div className="btn-group href_modal_body_buttons">
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">
                                                                    <a
                                                                        href="https://genpactonline.sharepoint.com/:b:/r/sites/LeanDigitalTransformation/Documents/KM%20Page%20-%202021/Certification%20Guidelines,%20SOPs%20%26%20Handbooks/Certification%20guidelines,%20SOPs%20%26%20Handbooks/Systems%20%26%20Tools/Helpmate-Data%20Related%20Request/ProGEAR%20Value%20Delivery%20Category%20Addition%20SOP.pdf?csf=1&web=1&e=5kKbFg"
                                                                        style={{ color: "#FFF" }}
                                                                        target="_blank"
                                                                    >
                                                                        Click Here
                                                                    </a>
                                                                </button>
                                                                <button
                                                                    className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                                                                    onClick={(e) =>
                                                                        this.setState({ showHrefModal: false })
                                                                    }
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : null}




                                    <div style={{ borderBottom: '1px solid lightgrey', marginTop: 10, marginBottom: 15 }} />
                                    <div className="btn-group" style={{ marginTop: 15 }}>
                                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.submitIdea}>Submit</button>
                                        <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.cancelEvent}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default MbbMonetizationApproval
